import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Ícones de seta para expandir/colapsar

const Checklist = ({ formData }) => {
  const [isExpanded, setIsExpanded] = useState(false); // Estado para controlar se o checklist está expandido

  const checklistItems = [
    { label: 'Nome do Paciente', value: formData.nomePaciente },
    { label: 'Data de Emissão', value: formData.dataEmissao },
    { label: 'Código CID', value: formData.cid },
    { label: 'Dias de Afastamento', value: formData.diasAfastamento },
    { label: 'Assinatura Digital', value: formData.assinaturaDigital },
    { label: 'Local de Atendimento', value: formData.localAtendimento },
    { label: 'Nome do Médico', value: formData.nomeMedico, isLink: true },
    { label: 'CRM do Médico', value: formData.crmMedico, isLink: true },
    { label: 'Estado do CRM', value: formData.estadoCRM, isLink: true },
  ];

  // Itens que estão incompletos
  const incompleteItems = checklistItems.filter((item) => !item.value);

  // Alterna o estado expandido
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="p-6 rounded-lg mb-6 bg-white shadow-md border">
      {/* Título e botão de colapso */}
      <div className="flex justify-between items-center mb-4 border-b pb-2">
        <h3 className="text-xl font-bold text-gray-800">
          Checklist de Preenchimento
        </h3>
        <button
          type="button"
          className="text-gray-600 hover:text-gray-800 focus:outline-none"
          onClick={toggleExpand}
          aria-expanded={isExpanded}
        >
          {isExpanded ? <FaChevronUp size={20} /> : <FaChevronDown size={20} />}
        </button>
      </div>

      {/* Mostra os itens do checklist apenas quando está expandido */}
      {isExpanded && (
        <>
          <ul className="space-y-3">
            {checklistItems.map((item, index) => (
              <li
                key={index}
                className={`flex items-center gap-2 p-3 rounded-md ${
                  item.value
                    ? 'text-green-600 bg-green-50'
                    : 'text-red-600 bg-red-50'
                }`}
              >
                {/* Ícone de check ou X */}
                <span
                  className={`inline-block w-6 h-6 text-center rounded-full ${
                    item.value
                      ? 'bg-green-600 text-white'
                      : 'bg-red-600 text-white'
                  }`}
                >
                  {item.value ? '✓' : '✗'}
                </span>

                {/* Verifica se o item é um link e se está vazio */}
                {item.isLink && !item.value ? (
                  <Link
                    to="/perfil-de-usuario"
                    className="underline text-blue-600 hover:text-blue-800"
                  >
                    {item.label} (Cadastrar)
                  </Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>

          {/* Mensagem de campos incompletos */}
          {incompleteItems.length > 0 && (
            <p className="text-red-600 mt-4 font-semibold">
              Preencha os campos marcados antes de gerar o atestado.
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default Checklist;
